import {Component, inject} from '@angular/core';
import {NgClass} from "@angular/common";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {PaddockStore} from 'src/app/domain/assets/paddocks/paddock.store';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {
  PaddockButtonComponent
} from "src/app/presentation/main-view/information-center/animals/paddocks/paddock-button/paddock-button.component";
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {Router} from '@angular/router';
import {UserStore} from 'src/app/domain/user/user.store';

@Component({
  selector: 'app-paddocks',
  imports: [
    NgClass,
    PaddockButtonComponent,
    GenericButtonComponent
],
  templateUrl: './paddocks.component.html',
  styleUrl: './paddocks.component.css'
})
export class PaddocksComponent {

  paddockStore = inject(PaddockStore);

  userStore = inject(UserStore);

  private mainViewStore = inject(MainViewStore);
  private router = inject(Router);

  constructor(
    protected viewportService: ViewportService
  ) {}

  back(): void {
    this.router.navigate(['/main/information-center']);
  }

  close() {
    this.mainViewStore.hideChildComponent();
  }

  addPaddocks() {
    if (!this.userStore.canEdit()) return;

    this.router.navigate(['/main/add-paddocks']);
  }
}
